/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Hub from '@/events/hub';
import _ from 'lodash';
import { router } from '@/plugins/vue-router';
import {
  HOME,
  FAVPROJECTS,
  ADDFAVPROJECTS,
  DELETEFAVPROJECTS,
  PROJECTDETAILS,
  GETNOTIFICATIONS,
  ADDNOTIFICATIONS,
  UPDATENOTIFICATIONS,
  FOOTERPROJECTS,
  GETBIDSTRENGTH,
  LOCALITIES,
  TAGS,
  RESET,
  SETOVERLAYSTATE,
  SHOWWONLOSTBID,
  SHOWAUCTIONLOST,
  SITEDRM,
  SETCITY,
  SETCOMPAREDATA,
  SETPROJECTLIST,
  SETUNITDETAILS,
  ADDFAVUNITS,
  DELETEFAVUNITS,
  GETLISTINGDATA,
  UPDATEPROJECT,
  UPDATESTATS,
  UPDATEUNITS,
  UPDATEBID,
  UPDATEFAVUNITSIGNAL,
  REMOVESOLDUNIT,
} from './mutation-types';

export default {
  [RESET](state) {
    state.favProjects = null;
    state.favUnits = null;
    state.projectDetails = null;
    state.notifications = null;
  },
  [HOME](state, payload) {
    state.homeProjects = payload.projects;
    state.homeDevelopers = payload.developers;
  },
  [SETOVERLAYSTATE](state, payload) {
    state.overlayState = payload;
  },
  [FAVPROJECTS](state, payload) {
    state.favProjects = payload.fav_projects;
    state.favUnits = payload.fav_units;
  },
  [ADDFAVPROJECTS](state, payload) {
    if (payload.unit_id) {
      state.favUnits.push({
        project_id: payload.project_id,
        fav_id: payload.fav_id,
        unit_id: payload.unit_id,
      });
    } else {
      state.favProjects.push({
        project_id: payload.project_id,
        fav_data: {
          isFav: true,
          fav_id: payload.fav_id,
          units: [],
        },
      });
    }
  },
  [DELETEFAVPROJECTS](state, payload) {
    if (payload.isUnit)
      state.favUnits = state.favUnits.filter(m => `${m.fav_id}` !== `${payload.fav_id}`);
    else
      state.favProjects = state.favProjects.filter(m => `${m.fav_data.fav_id}` !== `${payload.fav_id}`);
  },
  [PROJECTDETAILS](state, payload) {
    state.projectDetails = payload;
    state.projectFavUnit = payload.favourite;
    // if (state.projectDetails.projects.categories.length) {
    //   state.projectDetails.projects.categories[0].projects
    //   = state.projectDetails.projects.categories[0]
    //   .projects.map(m => parseInt(Object.keys(m)[0], 10));
    // }
  },
  [GETNOTIFICATIONS](state, payload) {
    state.notifications = payload;
  },
  [ADDNOTIFICATIONS](state, payload) {
    if (payload) {
      payload.is_read = false;
      if (state.notifications)
        state.notifications.unshift(payload);
      else
        state.notifications = [payload];
    }
  },
  [UPDATENOTIFICATIONS](state) {
    if (state.notifications) {
      state.notifications.forEach((m) => {
        m.is_read = true;
      });
    }
  },
  [FOOTERPROJECTS](state, payload) {
    state.footerProjects = payload;
  },
  [LOCALITIES](state, payload) {
    state.localities = payload;
  },
  [TAGS](state, payload) {
    state.tags = payload;
  },
  [SITEDRM](state, payload) {
    state.siteDrm = payload;
  },
  [GETBIDSTRENGTH](state, payload) {
    state.bidStrength = payload.strength;
  },
  [SHOWWONLOSTBID](_state, payload) {
    Hub.$emit('open-modal');
    Hub.$emit('set-modal-data', payload, 'won-lost-bid');
  },
  [SHOWAUCTIONLOST](_state, data) {
    Hub.$emit('open-modal');
    Hub.$emit('set-modal-data', data, 'auction-end');
  },
  [SETCITY](state, payload) {
    state.city = payload;
  },
  [SETCOMPAREDATA](state, payload) {
    const data = {};
    payload.forEach((item) => {
      data[item.id] = item;
    });
    state.compareData = data;
  },
  [SETPROJECTLIST](state, payload) {
    state.projectList = payload;
  },
  [SETUNITDETAILS](state, payload) {
    state.unitDetails = payload;
  },
  [ADDFAVUNITS](state, payload) {
    state.projectFavUnit.push(payload);
  },
  [DELETEFAVUNITS](state, payload) {
    state.projectFavUnit = state.projectFavUnit.filter(m => `${m.fav_id}` !== `${payload.fav_id}`);
  },
  [GETLISTINGDATA](state, payload) {
    if (payload.project_details)
      state.listData = payload.project_details;
    else
      state.listData = payload;
  },
  [UPDATEPROJECT](state, payload) {
    if (payload) {
      const path = window.location.href;
      if (router.currentRoute.name === 'home.projectdetails' && parseInt(router.currentRoute.query.id, 10) === payload.project.id) {
        const pd = state.projectDetails;
        const keys = Object.keys(payload);
        keys.forEach((m) => {
          pd[m] = payload[m];
        });
        state.projectDetails = pd;
      } else if (path.includes('/') && !payload.demo) {
        state.homeProjects.forEach((m, index) => {
          if (m.id === payload.project.id) {
            state.homeProjects.splice(index, 1);
            if (payload.project.auction_status !== 'CLOSED')
              state.homeProjects.push(payload.project);
          }
        });
        const matchedObj = _.find(state.homeProjects, m => m.id === payload.project.id);
        if (!matchedObj && payload.project.auction_status !== 'CLOSED')
          state.homeProjects.push(payload.project);
      }
    }
  },
  [UPDATESTATS](state, payload) {
    state.stats = payload;
  },
  [UPDATEUNITS](state, payload) {
    if (payload) {
      if (router.currentRoute.name === 'home.projectdetails' && parseInt(router.currentRoute.query.id, 10) === payload.project_id) {
        state.unitDetails = payload.unit_data;
        console.log('Mutation UPDATEUNITS executed', {
          payload,
          state,
        });
      }
    }
  },
  [UPDATEBID](state, payload) {
    if (router.currentRoute.name === 'home.projectdetails' && parseInt(router.currentRoute.query.id, 10) === payload.project_id) {
      if (state.projectDetails && state.projectDetails.bid) {
        state.projectDetails.bid.bid_amount = payload.bid_amount;
        state.projectDetails.bid = payload;
      }
    }
  },
  [UPDATEFAVUNITSIGNAL](state, payload) {
    if (router.currentRoute.name === 'home.projectdetails' && parseInt(router.currentRoute.query.id, 10) === payload.project_id)
      state.projectFavUnit = [];
  },
  [REMOVESOLDUNIT](state, payload) {
    if (router.currentRoute.name === 'home.projectdetails' && parseInt(router.currentRoute.query.id, 10) === payload.project_id
    && state.projectFavUnit && state.projectFavUnit.length)
      state.projectFavUnit = state.projectFavUnit.filter(m => m.unit_id !== payload.unit_id);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/home/mutations.js